/**
 * Trava de rolagem do <body> compartilhada entre modais/drawers
 *
 * Vários modais podem estar abertos ao mesmo tempo (ex.: modal de opções dentro
 * do "Novo pedido"). Cada um pede a trava; a rolagem só volta ao valor anterior
 * quando o último fechar — fechar o modal de cima não destrava o de baixo.
 *
 * @author Equipe VendeAi
 * @since 1.4.0
 */

let lockCount = 0;
let previousOverflow = '';

/** Trava a rolagem do body; devolve a função que libera esta trava (idempotente) */
export function lockBodyScroll(): () => void {
  if (typeof document === 'undefined') return () => {};
  if (lockCount === 0) {
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  lockCount += 1;

  let released = false;
  return () => {
    if (released) return;
    released = true;
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
      document.body.style.overflow = previousOverflow;
    }
  };
}
